import React, { Component } from 'react';
import { string, arrayOf, object, number } from 'prop-types';
import compose from 'lodash/flowRight';
import { promotedFiltersShape } from 'shapes';
import { withPromotedFilters, connectCurrentRefinements } from 'connectors';
import { isCurrentRefinementItemsChanged } from './utils';
import PromotedFilters from '../PromotedFilters/PromotedFilters';

export class PromotedFiltersWrapper extends Component {
    static propTypes = {
        className: string,
        promotedFilters: arrayOf(promotedFiltersShape).isRequired,
        items: arrayOf(object).isRequired,
        categoryId: number,
    };

    static defaultProps = {
        className: null,
        categoryId: null,
    };

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    constructor(props) {
        super(props);
        this.state = {};
    }

    shouldComponentUpdate(nextProps) {
        const { items, promotedFilters, className } = this.props;

        return (
            isCurrentRefinementItemsChanged(items, nextProps.items) ||
            promotedFilters !== nextProps.promotedFilters ||
            className !== nextProps.className
        );
    }

    render() {
        if (this.state.hasError) {
            console.warn(
                `PromotedFilters in category "${this.props.categoryId}" is broken.`,
                this.state.error,
            );
            return null;
        }

        const { promotedFilters, className, items } = this.props;

        return (
            promotedFilters.length > 0 && (
                <PromotedFilters
                    className={className}
                    promotedFilters={promotedFilters}
                    currentRefinements={items}
                />
            )
        );
    }
}

export default compose(
    withPromotedFilters,
    connectCurrentRefinements,
)(PromotedFiltersWrapper);
